import { SxProps, Theme } from '@mui/material/styles';

export const dashboardSx: Record<string, SxProps<Theme>> = {
  container: {
    display: 'block',
    width: '100%',
    minWidth: '100%',
    '& .react-draggable': {
      cursor: 'unset',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '8px 16px',
    marginBottom: '8px',
  },
};
